import useSWR from 'swr'
import useSWRMutation from 'swr/mutation'

import { apiDefaultFetcher, apiGetBlobFetcher } from '@/common/api/fetcher'
import {
  DownloadRewritesCsvVars,
  GetMediaDriverDashboardResponse,
  GetMediaDriverDashboardVars,
  MediaDriverApiPath
} from '@/common/api/params/mediaDriver'
import { useShowToastIfMutationError } from '@/common/app/toast'

export const useMediaDriverDashboardApi = (vars: GetMediaDriverDashboardVars) => {
  return useSWR<GetMediaDriverDashboardResponse, Response, [string, GetMediaDriverDashboardVars]>(
    [MediaDriverApiPath.GET_MEDIA_DRIVER_DASHBOARD, vars],
    apiDefaultFetcher
  )
}

// リライト一覧CSVのダウンロード
export const useDownloadRewritesCsv = (onSuccess: (blob: Blob) => void) => {
  const showError = useShowToastIfMutationError()
  return useSWRMutation<Blob, Response, string, DownloadRewritesCsvVars>(
    MediaDriverApiPath.DOWNLOAD_REWRITES_CSV,
    apiGetBlobFetcher,
    { onSuccess, onError: showError }
  )
}
